import { useAuth } from "../context/AuthContext"
import { UserRoleEnums } from "../utility/userRoles";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const ReRouting = () => {
    const {user } = useAuth();
    const role = user?.user.role;
    const navigate = useNavigate();

    useEffect(()=>{
        if(role === UserRoleEnums.SUPER_ADMIN){
            navigate('/tenant-listing');
        }else{
            navigate('/dashboard');
        }
    },[role])
    return (
        <></>
    )
}